import { ref } from 'vue';

export default () => {
    const show = ref(false)
    const row = ref({})

    function open(e = {}) {
        row.value = e;
        show.value = true;
    }

    function close() {
        show.value = false;
        row.value = {};
    }

    return { show, row, open, close }
}